// REMIX HMR BEGIN
import * as __hmr__ from "remix:hmr";
if (import.meta) {
import.meta.hot = __hmr__.createHotContext(
//@ts-expect-error
"app\\components\\shared\\PhotoGallery\\index.ts"
);
import.meta.hot.lastModified = "1757171103359.483";
}
// REMIX HMR END

export { PhotoGallery } from "./PhotoGallery";
export type { PhotoGalleryImage } from "./PhotoGallery";